export default "__VITE_ASSET__D57OzxLe__"